import { RemoveRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { IssueType } from '../../IssueTypesContext/types'
import { Permission } from '@cims-online/shared'
import { useIssueTypesContext } from '../../IssueTypesContext'
import { useSoftRemoveIssueTypeMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleRemoveNotification } from 'hooks/notificationHandler'

export function useRemove(): RemoveRowActionOptions<IssueType> {
  const { refetch } = useIssueTypesContext()
  const [softRemove] = useSoftRemoveIssueTypeMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      softRemoveIssueType: {
        type: { name },
      },
    }) => simpleRemoveNotification(name),
  })
  return {
    permission: Permission.RemoveRestoreIssueType,
    onRemove: async ({ id }) => {
      await softRemove({ variables: { id } })
      refetch()
    },
    disabled: ({ issues }) =>
      issues.length
        ? {
            message:
              'Issue Types cannot be deleted if they are associated with one or more Issues',
          }
        : false,
  }
}
